import { Injectable } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root',
})
export class PermissionLoaderService {
  constructor(private permissionsService: NgxPermissionsService) {}

  load(): Promise<void> {
    return new Promise((resolve) => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');

      if (user && user.permissions) {
        this.permissionsService.loadPermissions(user.permissions);
      }

      resolve();
    });
  }
}
